import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { Touch } from 'vuetify/lib/directives'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify, {
  directives: {
    Touch
  }
})

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#38B8FF',
        v2_primary: '#1FAD1F',
        olbrand: '#0078CE',
        olblack: '#272727',
        olgrey: '#767676',
        olred: '#F44336',
        olreddark: '#D81002',
        olorange: '#FF931E'
      },
      dark: {
        primary: '#38B8FF',
        v2_primary: '#1FAD1F',
        olbrand: '#0078CE',
        olblack: '#272727',
        olgrey: '#767676',
        olred: '#F44336',
        olreddark: '#D81002',
        olorange: '#FF931E'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
}

export default new Vuetify(opts)
